import IConnectedCalendar from '@/types/IConnectedCalendar';
import IHost from '@/types/IHost';

export function getCalendars(hosts: IHost[]): IConnectedCalendar[] {
	let calendars: IConnectedCalendar[] = [];

	hosts.forEach((host) => {
		calendars = calendars.concat(host.calendars);
	});

	return calendars;
}

export function decodeThirdPartyCalendars() {}

export function getSortedCalendars(calendars: Array<IConnectedCalendar>): Array<IConnectedCalendar> {
	return calendars.sort((a, b) => {
		if (a.provider === b.provider) {
			return a.name.localeCompare(b.name);
		}

		if (a.provider === 'GOOGLE') {
			return -1;
		}

		return 1;
	});
}

export default {
	getCalendars,
	decodeThirdPartyCalendars,
};
